import { SmartFieldProjectExperience } from "./SmartFieldProjectExperience";
import { SmartFieldKeyPersonnel } from "./SmartFieldKeyPersonnel";
import { SmartFieldCorporateDocument } from "./SmartFieldCorporateDocument";
import { RfxQuestion } from "newui/features/Rfx/types/returnable-schedule-question.type";

type SmartFieldName = "Project Experience" | "Key Personnel" | "Corporate Documents";

interface SmartFieldQuestionnaireProps {
	name: string;
	[key: string]: unknown;
	answer?: Record<string, unknown>;
	className?: string;
	isClientPreview?: boolean;
	questionObject: RfxQuestion;
	required?: boolean;
	smartField: SmartFieldName;
}

export const SmartFieldQuestionnaire: React.FC<SmartFieldQuestionnaireProps> = ({
	smartField,
	isClientPreview,
	answer,
	questionObject,
	...props
}) => {
	// Render the appropriate component based on smartField
	switch (smartField) {
		case "Project Experience":
			return (
				<SmartFieldProjectExperience
					isClientPreview={isClientPreview}
					answer={answer}
					{...props}
					question={questionObject}
				/>
			);
		case "Key Personnel":
			return (
				<SmartFieldKeyPersonnel
					isClientPreview={isClientPreview}
					answer={answer}
					{...props}
					question={questionObject}
				/>
			);
		case "Corporate Documents":
			return (
				<SmartFieldCorporateDocument
					isClientPreview={isClientPreview}
					answer={answer}
					{...props}
					question={questionObject}
				/>
			);
		default:
			return <div>Unknown smart field type: {smartField}</div>;
	}
};
